module.exports = __webpack_public_path__ + "img/gatewayicon.dd5ac059.png";